//Include Both Helper File with needed methods

import {
  
   getHomePortfolio,
    
} from "../../../helpers/fakebackend_helper";



import { createAsyncThunk } from "@reduxjs/toolkit";


export const home_portfolioThunk = createAsyncThunk("home_portfolioThunk", async ({ params, token }, { rejectWithValue } ) => {
  try {
    const response = await getHomePortfolio( params, token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










